<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Physical Resources Management
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Resources</li>
        <li class="active">Physical Resources List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Physical Resources List</h3>
              <div class="action-button pull-right">
                <div>
                  <input type="text" placeholder="Type here to search and press 'Enter'" v-reset-input='' v-on:keyup="searchResources" class="form-control mrgn-right-20px searchBox" v-model="searchResource"/>
                </div>
                <!-- <input type="button" :disabled="loading" class="btn btn-primary mrgn-right-20px" value="Add Physical Resources" v-on:click="showModal()" /> -->
                <router-link class="btn btn-primary" :to="`virtual-resources-addOrUpdate`">Add Physical Resources</router-link>
              </div>
            </div>
              <!-- /.box-header -->
            <div class="loader" v-if="actionInProgress">
              <img src="/static/assets/loader/nivi-loader.svg" />
            </div>
            <div class="box-body">
              <table class="table table-striped table-apps">
                <thead>
                  <!-- <th>Id</th> -->
                  <th>Resource Name <i class="fa fa-arrow-up" @click="sortResources('data.full_name','asc')"></i><i class="fa fa-arrow-down" @click="sortResources('data.full_name','desc')"></i></th>
                  <th align='center'>Country</th>  
                  <th>Client <i class="fa fa-arrow-up" @click="sortResources('data.client_name','asc')"></i><i class="fa fa-arrow-down" @click="sortResources('data.client_name','desc')"></i></th>
                  <!-- <th>Resource Type <i class="fa fa-arrow-up" @click="sortResources('data.resource_type_name','asc')"></i><i class="fa fa-arrow-down" @click="sortResources('data.resource_type_name','desc')"></i></th> -->
                  <th>Created On</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </thead>
                <tbody>
                  <tr v-if="resourcesData.length === 0 && !loading"><td colspan="7" align="center">No Result found.</td></tr>
                  <tr v-show="resourcesData.length" v-for="(keyword, index) in resourcesData" :key="index">
                    <!-- <td>{{keyword.id}}</td> -->
                    <td>{{keyword.full_name}}</td>
                    <td>{{keyword.country_name}}</td>                   
                    <td>{{keyword.client_name}}</td>                    
                    <!-- <td>{{keyword.resource_type_name}}</td> -->
                    <td>
                      <span v-if="keyword.createdAt">{{formatDate(keyword.createdAt, 'd/M/Y hh:ss')}}</span>
                      <span v-if="!keyword.createdAt">--</span>
                    </td>
                    <td>
                    <!-- <div :disabled="loading" class="btn btn-primary mrgn-right-20px" 
                     v-on:click="showModal(keyword)" > 
                     <i class="fa fa-pencil" aria-hidden="true"></i>
                     </div> -->
                      <router-link :to="`virtual-resources-addOrUpdate?resourceId=${keyword.id}`"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                    </td>
                    <td>
                      <i class="fa fa-times-circle" aria-hidden="true" v-on:click="showDeleteConfirmationPopup(keyword, index)"></i>
                    </td>             
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    
      <deleteConfirmationModal
        v-if="isDeleteConfirmationVisible"        
        @close="closeConfirmationModal" 
        @deleteResources="deleteResources"
        :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
        :confirmationMessage="confirmationMessage" 
        :actionToBePerformed="actionToBePerformed"
        />

      <!-- <addResourcesModal 
      v-if="isModalVisible"     
      :actionToBePerformed="actionToBePerformed"       
      :validationErrors="validationErrors"   
      :gRowObj="gRowObj"
      @close = "closeModal()"
      @addResources = "addResources($event)"
      @updateResources = "updateResources($event)"
      @deleteResources="deleteResources"
     /> -->

          <!-- <addResourcesModal 
      v-if="isModalVisible"               
      :popupTitle="popupTitle"        
      :gRowObj="messagePopupData.gRowObj"
      :primaryLangText="messagePopupData.primaryLangText"
      :secondaryLangText="messagePopupData.secondaryLangText"
      :allRows="messagePopupData.allRows"
      @closeModal = "closeModal()"
      @closeLoader = "closeLoader($event)"
      @onSubmit = "submitMessagePopup($event)"/> -->

       <!-- <Modal
        btnText="Press me, senpai 😊"
        :closeBtn="true"
        closeBtnHTML="<span>X</span>"
      >
        <modal
        v-show="isModalVisible"
        v-on:click="closeModal(keyword)"
        @close="closeModal"
      />
      </Modal>  -->
    <!-- /.content -->  
    <div class="pagination-container">
      <paginate v-if="pageCount > 0" v-model="page" :page-count="pageCount" :click-handler="getDataForSelectedPage" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"></paginate>
    </div> 
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import api from '../../../../utils/api'
import deleteConfirmationModal from './../../popup/deleteConfirmation'
import _ from 'lodash'
import { formatDate, getSelectorValue } from '../../../../utils/utilities'
import Paginate from 'vuejs-paginate'
export default {
  name: 'KeywordDashboard',
  components: {
    // 'addResourcesModal': addResourcesModal,
    'deleteConfirmationModal': deleteConfirmationModal,
    'paginate': Paginate
    // 'jw-pagination': JwPagination
  },
  async mounted () {
    await this.getAllResources()
    this.loading = false
  },
  data () {
    return {
      pageCount: 0,
      currentPage: 1,
      pageSize: 20,
      formatDate: formatDate,
      resourceSearchResult: [],
      keywordObj: {},
      searchResource: '',
      loading: false,
      actionInProgress: false,
      isModalVisible: false,
      isDeleteConfirmationVisible: false,
      validationErrors: [],
      resourcesData: [],
      clonedresourcesData: [],
      actionToBePerformed: 'Add Resource',
      confirmationMessage: 'Are you sure you want to delete this resource?',
      rowIndexToBeUpdated: 0,
      defaultRowObj: {
        id: null,
        full_name: '',
        country_id: '',
        country_name: '',
        client_id: '',
        client_name: '',
        resource_type_id: '',
        resource_type_name: '',
        classification_id: '',
        classification_name: '',
        physical_or_virtual: 'virtual',
        base_uri: '',
        services: [],
        resourcesText: []
      },
      gRowObj: {
        id: null,
        full_name: '',
        country_code_id: '',
        country_name: '',
        customer_id: '',
        customer_name: '',
        resource_type_id: '',
        resource_type_name: '',
        classification_id: '',
        classification_name: '',
        physical_or_virtual: 'virtual',
        base_uri: '',
        services: [],
        resourcesText: []
      }
    }
  },
  methods: {
    showModal (resource) {
      this.validationErrors = []
      this.isModalVisible = true
      if (resource) {
        this.gRowObj = resource
      }
    },
    /**
     * @function closeConfirmationModal
     * @description Function to close delete confirmation popup
     */
    closeConfirmationModal () {
      this.isDeleteConfirmationVisible = false
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    /**
     * @function closeModal
     * @description Function to close modal and reset all the variables
     */
    closeModal () {
      console.log('inside closeModal function')
      this.rowIndexToBeUpdated = 0
      this.isModalVisible = false
      this.isDeleteConfirmationVisible = false
      this.validationErrors = []
      this.gRowObj = Object.assign({}, this.resetGRowObj())
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    showDeleteConfirmationPopup (resourcesData, index) {
      console.log('inside showDeleteConfirmationPopup')
      this.actionToBePerformed = 'Delete Resources'
      this.confirmationMessage = 'Are you sure you want to delete this Resources?'
      this.isDeleteConfirmationVisible = true
      this.rowIndexToBeUpdated = index
    },
    /**
     * @function closeModal
     * @description Function to close modal and reset all the variables
     */
    searchResources (event) {
      console.log(event)
      console.log(this.searchResource)
      this.currentPage = 1
      // let executesearchResource = false
      if (this.searchResource !== '' && this.searchResource !== undefined) {
        if (event.key === 'Enter') {
          // executesearchResource = true
          this.getAllResources()
        }
      }
    },
    onResetsearchResource () {
      this.getAllResources()
    },
    /**
     * @function getDataFromGoogleSheet
     * @description Get Keywords from Google sheet
     */
    async getAllResources () {
      this.loading = true
      let skip = 0
      let selector = {}
      selector.isdeleted = false
      if (this.currentPage > 1) {
        skip = (this.currentPage - 1) * this.pageSize
      }
      if (this.searchResource !== '' && this.searchResource !== undefined) {
        selector.keyword = { $regex: this.searchResource, $options: 'i' }
      }
      let queryParams = {
        selector: getSelectorValue(selector),
        skip: skip,
        limit: this.pageSize,
        searchText: this.searchResource || '',
        sort: {
          createdAt: -1
        }
      }
      // this.config['stages'] = this.stages
      // api.buildRequest('getAllResources', 'POST', {sheetReference: 'keyword', workSheetIndex: 1})
      return new Promise(resolve => {
        api.buildRequest('getPhysicalResourcesList', 'POST', queryParams)
            .then(response => {
              this.loading = false
              if (response.status === 200) {
                console.log(response)
                if (response.data.payload.resources.length > 0) {
                  this.resourcesData = response.data.payload.resources
                  this.clonedresourcesData = this.resourcesData
                  this.pageCount = Math.ceil(response.data.payload.resourcesCount / this.pageSize)
                } else {
                  this.resourcesData = []
                  this.clonedresourcesData = this.resourcesData
                  this.pageCount = 0
                  if (this.searchResource === '') {
                    // this.getKeywordsFromGoogleSheet()
                  }
                }
              } else {
                console.log('something went wrong')
              }
              resolve(true)
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
      })
    },
    /**
     * @author Vishal Wayachal <vishal.wayachal@mobifillia.com>
     * @description Update Keyword in Google Sheet
     * @param {Object} resourcesData Keyword to be updated
     */
    updateResources (resourcesData) {
      this.actionInProgress = true
      console.log('updating row in the google sheet')
      console.log(this.rowIndexToBeUpdated)
      console.log(this.gRowObj)
      let trimmedObj = {}
      trimmedObj = this.trimJsonObj(this.gRowObj)
      const newRowObj = {
        id: trimmedObj.id,
        createdAt: trimmedObj.createdAt,
        data: trimmedObj
      }
      // this.clonedresourcesData[this.rowIndexToBeUpdated] = Object.assign({}, newRowObj)
      this.clonedresourcesData.splice(this.rowIndexToBeUpdated, 1, newRowObj)
      console.log('updated data')
      console.log(this.clonedresourcesData)
      this.resourcesData = this.clonedresourcesData
      const googleSheetRowOffset = this.rowIndexToBeUpdated + 1
      const params = {
        sheetReference: 'keyword',
        workSheetIndex: 1,
        updatedRow: trimmedObj,
        options: {
          offset: googleSheetRowOffset,
          limit: 1
        },
        sheetData: this.resourcesData
      }
      var self = this
      api.buildRequest('updateResources', 'POST', params)
          .then(response => {
            this.actionInProgress = false
            if (response.status === 200) {
              self.isModalVisible = false
              self.closeModal()
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : 'Resource updated successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.isModalVisible = false
            self.closeModal()
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    /**
     * @author Vishal Wayachal <vishal.wayachal@mobifillia.com>
     * @description Add Keyword in Google Sheet
     * @param {Object} resourcesData Keyword to be updated
     */
    addResources (resourcesData) {
      this.actionInProgress = true
      console.log('addResources')
      console.log(this.rowIndexToBeUpdated)
      let trimmedObj = {}
      trimmedObj = this.trimJsonObj(this.gRowObj)
      console.log(trimmedObj)
      const newRowObj = {
        id: trimmedObj.id,
        data: trimmedObj
      }
      newRowObj.isdeleted = false
      newRowObj.createdAt = new Date()
      this.clonedresourcesData.unshift(newRowObj)
      this.resourcesData = this.clonedresourcesData
      const params = {
        sheetReference: 'keyword',
        workSheetIndex: 1,
        newRow: trimmedObj,
        sheetData: this.resourcesData
      }
      var self = this
      api.buildRequest('addResources', 'POST', params)
          .then(response => {
            self.actionInProgress = false
            self.closeModal()
            if (response.status === 200) {
              self.isModalVisible = false
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : 'Resource added successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.isModalVisible = false
            self.actionInProgress = false
            self.closeModal()
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    /**
     * @author Vishal Wayachal <vishal.wayachal@mobifillia.com>
     * @description Delete Keyword in Google Sheet
     * @param {Object} resourcesData Keyword to be updated
     */
    deleteResources () {
      this.loading = true
      console.log('deleteResources')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRowData = this.resourcesData[this.rowIndexToBeUpdated]
      this.resourcesData.splice(this.rowIndexToBeUpdated, 1)
      console.log('spliced resourcesData')
      console.log(this.resourcesData)
      const params = deletedRowData
      var self = this
      api.buildRequest('deleteVirtualResources', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            self.closeModal()
            if (response.status === 200) {
              self.isDeleteConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : 'Resource deleted successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isDeleteConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    getDataForSelectedPage (pageNum) {
      console.log('pageNum')
      console.log(pageNum)
      this.currentPage = pageNum
      this.getAllResources()
    },
    /**
     * @author Vishal Wayachal <vishal.wayachal@mobifillia.com>
     * @description Reset Row Data
     */
    resetGRowObj () {
      console.log('inside resetGRowObj method')
      return this.defaultRowObj
    },
    /**
     * @author Vishal Wayachal <vishal.wayachal@mobifillia.com>
     * @description Trim JSON Object
     */
    trimJsonObj (obj) {
      const trimmedObj = {}
      Object.keys(obj).forEach(function (key) {
        console.log(key, obj[key])
        trimmedObj[key] = obj[key]
        if (obj[key] !== undefined && typeof obj[key] === 'string') {
          trimmedObj[key] = obj[key].trim()
        }
      })
      return trimmedObj
    },
    onChangePage (pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems
    },
    sortResources (sortKey, order) {
      this.resourcesData = _.sortBy(this.resourcesData, [sortKey])
      if (order === 'desc') {
        this.resourcesData = _.reverse(this.resourcesData)
      }
      console.log(`sorted keywords=${this.resourcesData}`)
    }
  },
  watch: {
    searchResource: function () {
      console.log('watching searchkeyowrd')
      if (this.searchResource === '') {
        this.getAllResources()
      }
    }
  },
  computed: {
    filteredList () {
      this.resourceSearchResult = this.resourcesData.filter(keyword => {
        return keyword.id.toLowerCase().includes(this.searchResource.toLowerCase()) || keyword.data.keyword.toLowerCase().includes(this.searchResource.toLowerCase())
      })
      return this.resourceSearchResult
    }
  }
}
</script>
<style>
.mrgn-right-20px {
  margin-right: 20px;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
</style>


// WEBPACK FOOTER //
// physicalList.vue?0e3061cc